<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">行业解决方案</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

      <div class="mstation-introduce-content">
        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">行业背景</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            基于量子力学的第一性原理计算可以从原子尺度计算材料的性质，加深对材料特性的理解，为实验提供知道方向，将盲目试错变成理性设计，助力新材料研发，降低研发成本和周期。第一性原理计算已在学术界有30年
            的应用历史，渗透到材料研究的各个方面。近20年来，第一性原理计算在中国也有了长足的发展，相关论文数量呈指数级增长，材料计算在整个材料研发中占比高达20%，市场潜力巨大。
          </p>
        </div>

        <!--    <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/industrial1.png">
       </div>-->

        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">行业需求</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info1">
          <div class="mstation-introduce-content-info-text">
            <br/><br/>
            <strong>新能源</strong><br/>
            在碳中和与碳达峰大背景下，新能源是未来20-30年的一个主要工业发展方向，但无论是二次锂电池，还是水分解、氢储存等研究方向均有不同的技术问题，如高容量正负极材料筛选、
            水分解催化剂设计、氢储材料优化设计等，这些问题都需要借助量子力学从原子尺度给出合理的解决方案或建议，新能源属于原子领域，而非机械领域，需要原子尺度的计算模拟<br/><br/>
            <strong>半导体</strong><br/>
            随着器件不断接近原子尺度，连续介质的特性不再成立，原子效应、量子效应明显，摩尔定律就要完结，电子器件不再是一个体材料的电子扩散输运的经典器件，而是一个充满量子效应、
            多物理现象、原子纳米尺度的器件。“More than Moore”时代将是一个研发投入更多的时代。对于半导体器件的研发，原子尺度的计算模拟是必不可少的
          </div>
          <div class="mstation-introduce-content-img">
            <br/><br/><br/>
            <img  src="../../assets/solution/industrial2.png">
          </div>
          <div class="mstation-introduce-content-info-text">
            <strong>化工催化</strong><br/>
            近年来，得益于理论计算的快速发展，基于原子尺度的计算模拟在催化领域的运用日益广泛，
            可帮助研发人员深入研究催化反应过程，更清楚地找到问题所在，解决反应过程中动态微观结构演变、反应路径等问题，助力工业制品的研发
            <br/><br/>
            <strong>生物制药</strong><br/>
            靶向药的兴起，让小分子药物研发充满生机，疫情告诉我们，社会需要快速开发药物的能力，时间紧迫，生物制药行业已经有几十年分子计算的经验，
            但问题在于传统的材料模拟不够精确，所以如何提供计算精度和准确性是亟需解决的问题
            <br/><br/>
            <strong>合金</strong><br/>
            合金材料覆盖工业方方面面，企业需要更符合行业需求的合金材料。铁、钛等自身具有结构相变的材料可设计性非常强，通过技术手段可改变其内部原子结构，
            使其强度等特性发生改变，而进行原子尺度的计算模拟，可以使材料内部性质的计算更加精确，提升合金材料的研发效率


          </div>
        </div>


        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">应用案例</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例1：提高高镍三元正极材料循环稳定性</strong><br/>
            高镍三元材料由于具有较高的克容量而逐渐成为动力电池的首选材料。但是，在高镍材料的合成和充放电循环过程中容易出现大量的锂镍混排缺陷，导致材料容量快速衰减。元素掺杂可以有效改善锂镍混排问题，提高三元材料的容量。
            龙讯旷腾通过第一性原理计算方法帮助某正极材料公司进行了掺杂元素的筛选。
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case1.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例2：高镍三元锂正极材料电压平台及容量计算</strong><br/>
            高镍三元锂离子电池正极材料LiNi<sub>1−x−y</sub>Co<sub>x</sub>Mn<sub>y</sub>O<sub>2</sub>（NCM）凭借比容量高、成本较低和安全性优良等优势，成为研究的热点，被认为是极具应用前景的锂离子动力电池正极材料。
            层状结构NCM中，镍是主要的氧化还原反应元素，因此，提高镍含量可以有效提高NCM的比容量。某锂电池材料公司重点发展磷酸铁锂和高镍三元材料，龙讯旷腾用第一性原理计算帮助其计算了高镍三元材料的电压平台和容量。
            通过高通量计算，寻找到了每个浓度下能量相对较低的结构，其平均能量相图揭示了反应过程中能量较稳定的相，计算了稳定性的电压和理论容量。

          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case2.png">
       </div>


       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例3：全固态电池正极包覆材料筛选</strong><br/>
            固态电解质与正极材料直接接触时会发生反应，固态电解质被氧化，形成电阻性界面并增加电池阻抗，导致容量快速衰退。为寻找合适的正极包覆材料，抑制这些氧化反应发生，
            龙讯旷腾借助第一性原理计算，帮助某固态电池公司进行正极包覆材料筛选。


          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case3.png">
       </div>

       
       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例4：硫化物固态电解质筛选</strong><br/>
            硫化物电解质相比于氧化物和聚合物电解质具有更高的离子电导率，但稳定性差。元素掺杂是解决硫化物电解质稳定性的一个重要手段，龙讯旷腾通过第一性原理计算和机器学习力场方法进行了掺杂元素和掺杂比例的筛选，
            帮助某固态电池公司找到了合适的掺杂元素及可能的配比范围。
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case4.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例5：CMOS器件模拟</strong><br/>
            PWmatTransport采用量子散射态方法计算量子输运，与算法复杂度规模在O(N3)的NEGF方法不同，这种散射态方法可以直接计算给定能量的散射态。这种方法可以线性扩展系统大小，因此适用于大型系统的仿真。
            PWmatTransport已被用于模拟具有6nm沟道长度的实际CMOS器件，该体系包含5000个原子。同时，为了模拟真实器件，我们还开发了不同电极采用不同费米能级的非平衡自洽计算方法。

          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case5.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例6：PWmat嵌入农机装备材料研发平台</strong><br/>
            农机装备关键材料面临着高强化、耐磨性、耐蚀性、自主率的轴齿轮材料一致性等方面的优化，需要有效突破生产应用中的关键共性技术，提升我国农机制造业整体技术水平。
           龙讯旷腾PWmat能够得出材料性能数据（力学性能、成形性能、成分性能），将性能数据和材料企业提供的材料工艺生产信息交叉对比，加速设计验证新材料。
           PWmat嵌入研发平台不仅能够总结多种农机材料的共性性能要求和共性技术，提高农机材料（乃至机械材料）研发效率，还能探索材料信息平台整合研发的可能，和产业链其他企业合作形成材料研发全流程解决方案。
          </p>
        </div>


       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>案例7：PWmat嵌入钢铁行业研究平台</strong><br/>
            由于实验测量高温高压环境金属的相图成本较高、难度较大，产研界考虑通过计算材料的热力学性质进行完整和体系化了解，画出初步相图后就关键点进行实验确认。计算求解的原理为：
            通过求解不同结构的量子力学方程（第一性原理计算），得到材料的吉布斯自由能，确定相图的结构。
            在计算实践中，龙讯旷腾考虑材料本身能量、零点能、材料体积变化、原子振动熵、电子自旋方向熵、电子轨道排布熵等因素，构建了在压强、温度、磁排布等不同环境下计算相图的集成最优方案。
            在中国钢研院项目中，龙讯旷腾在不使用任何实验参数的情况下，仅通过利用以上计算流程得到了与实验相图趋势接近的Ti和Fe的计算相图。进一步利用极少的实验相变点数据，
            使用LDA与PBE交换关联泛函的校准、DFT+U校准等方法，修正密度泛函理论的第一性原理计算结果与实验的误差，得到在所有文献中与实验数据最为接近的第一性原理计算相图。
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case7.png">
       </div>

       <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">合作企业</div>
          <div class="mstation-introduce-line"></div>
        </div>

                
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/customer.png">
       </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "companyIntroduce"
}
</script>

<style scoped>
.mstation-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.mstation-introduce-background {
  margin-top: 70px;
}

.mstation-introduce-banner {
  overflow: hidden;
}

.mstation-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}

.mstation-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}

.mstation-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}

/* .mstation-introduce-content-img {
  text-align: center;
}

.mstation-introduce-content-img-png {
  margin-top: 50px;
  width: 300px;
} */


.mstation-introduce-content-title {
  padding-top: 50px;
}

.mstation-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}

.mstation-introduce-content-info {
  margin-top: 40px;
}
.mstation-introduce-content-info-text1 {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: bold;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 70px;
}
.mstation-introduce-content-info .mstation-introduce-content-info-text {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 30px;
}

.mstation-introduce-content-info1 {
  margin-top: 40px;
  display: flex;
}

.mstation-introduce-content-info1 .mstation-introduce-content-info-text {
  font-size: 15px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  flex: 1;
  margin-right: 0px;
  text-align: justify;
}
.mstation-introduce-content-info1 .mstation-introduce-content-img {
  flex: 1.2;
  margin-left: 10px;
  margin-right: 10px;
}
.mstation-introduce-content-info1 .mstation-introduce-content-img img {
  margin-top: 10px;
  width: 100%;
}

.industrial1-introduce-content-img-png {
  margin-top: 10px;
  width: 100%;
}
.mstation-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}

.mstation-introduce-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}

.mstation-introduce-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}

.mstation-introduce-td {
  height: 45px;
}

.mstation-introduce-td:hover {
  background: rgba(73, 145, 201, 0.1);
}

.mstation-introduce-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}

.mstation-introduce-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding-left: 16px;
}

.mstation-introduce-fa {
  font-size: 16px;
  padding-right: 8px;
}

@media screen and (max-width:482px) {
  .mstation-introduce-container {
    max-width: 100%;
  }
}

@media screen and (min-width:482px) and (max-width:768px) {
  .mstation-introduce-container {
    max-width: 450px;
  }
}

@media screen and (min-width:768px) and (max-width:1100px) {
  .mstation-introduce-container {
    max-width: 736px;
  }
}

@media screen and (min-width:1100px) and (max-width:1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}

@media screen and (min-width:1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
</style>